module.exports = __webpack_public_path__ + "img/paysafecard.a654702c.svg";